export const PhaseType = {
  COMMAND: 'command',
  RESPONSE: 'response',
  MATRIX: 'matrix',
  ACCESS: 'access',
  DATA: 'data',
  TABLE: 'table',
  ANALYSIS: 'analysis',
  WARNING: 'warning',
  PROGRESS: 'progress',
} as const;

export type PhaseTypeValue = (typeof PhaseType)[keyof typeof PhaseType];

export const isStaticPhase = (type: PhaseTypeValue): boolean => {
  return ['matrix', 'table', 'access', 'warning'].includes(type);
};

export interface TerminalPhase {
  type: PhaseTypeValue;
  content: string;
  delay?: number;
  speed?: number;
  header?: string[];
  data?: string[][];
  duration?: number;
}

export interface TerminalConfig {
  title: string;
  typingSpeed: number;
  phaseDelay: number;
  matrixDelay: number;
  tableDelay: number;
  warningDelay: number;
  progressStyle?: 'blocks' | 'bar';
}

export interface TerminalProps {
  phases: TerminalPhase[];
  config?: Partial<TerminalConfig>;
  className?: string;
}
